import type { FunctionalComponent, SVGAttributes } from 'vue'

export const MinusIcon: FunctionalComponent<SVGAttributes> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path d="M7.09719 7.25781H1.83594V8.75781H7.09719H8.59869H13.8359V7.25781H8.59869H7.09719Z" fill="var(--colors-bg-icon-secondary)" />
    </svg>
  )
}
